import Vue from 'vue';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

// 去保存好的值
const system_key = localStorage.getItem('system_key');
if(!system_key){
    // // 获取设备信息
    // uni.getSystemInfo({
    //     success: function(res) {
    //         console.log(res)
    //         localStorage.setItem('system_key',res);
    //     }
    // })
}

// 判断获取后的值是什么语言
const lang_cur = system_key == 'en' ? 'en' : 'zh';
// 实例化VueI18n对象
const i18n = new VueI18n({
    // 默认语言
    locale: lang_cur || 'en',
    //  两种方式
    messages: {
        'en': require('./lang/en.js'),
        'zh': require('./lang/zh.js')
    }
})
// locale.i18n((key, value) => i18n.t(key, value)) //兼容element
// 抛出去
export default i18n
